module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui card",
    on: {
      "click": function($event) {
        return _vm.$emit('input', _vm.index)
      }
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h4', [_vm._v("\n      " + _vm._s(_vm.name) + "\n      "), (_vm.shirt.options[_vm.options.id]) ? _c('a', {
    staticClass: "ui tag label right floated"
  }, [_vm._v(_vm._s(_vm.price) + " €")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui cards"
  }, [_vm._l((_vm.options.parameters), function(parameter, index) {
    return [(
      _vm.shirt.options[_vm.options.id][parameter.code] &&
      _vm.shirt.options[_vm.options.id][parameter.code].picture
    ) ? [_c('div', {
      key: index,
      staticClass: "ui card cardimage"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "alt": " ",
        "src": _vm.shirt.options[_vm.options.id][parameter.code].picture
      }
    })])])] : [(_vm.shirt.options[_vm.options.id][parameter.code]) ? _c('div', {
      key: index,
      staticClass: "ui card cardtext"
    }, [_c('div', {
      staticClass: "text center aligned middle aligned content"
    }, [_vm._v("\n              " + _vm._s(_vm.shirt.options[_vm.options.id][parameter.code].name) + "\n            ")])]) : _vm._e()]]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12704ee8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Designer/ParametersCard.vue
// module id = 481
// module chunks = 1